import { Committee, getCommitteeLabel, committeesArray } from '../../../models/committees.types';

export const getExamCommitteeNameFromId = (id: Committee): JSX.Element => {
  const result = getCommitteeLabel(id);
  return result ? <span style={{ marginLeft: '10px' }}>{result}</span> : <></>;
};

export const getCommitteesList = () => {
  return committeesArray.slice(0, -1).map((x: { name: string }) => x.name);
};
export const getExamCommitteeNameFromIdString = (id: number | undefined): string => {
  const result = committeesArray.find((a: { id: number }) => a.id === id);

  return result ? result.name : '';
};
export const getExamCommitteeId = (name: string | undefined): number[] | string[] => {
  const splittedCommittees: string[] | undefined = name ? name.split(',') : [];
  const result: string[] | number[] = splittedCommittees.map((committee) => {
    const result1 = committeesArray.find((a: { name: string }) => a.name === committee);
    return result1 ? result1.id.toString() : '';
  });
  return result;
};
export const convertToFilterItems = (): { label: string; value: string }[] => {
  const result = committeesArray.slice(0, -1).map((item: { id: Committee; name: string }) => ({
    label: item.name,
    value: item.id.toString(),
  }));
  return result;
};

export const convertToFilterLabelItems = (): { label: string; value: string }[] => {
  const result = committeesArray.slice(0, -1).map((item: { id: Committee; name: string }) => ({
    label: item.name,
    value: item.id.toString(),
  }));
  return result;
};

export const convertToDropdownFilterLabelItems = (): [string, string][] => {
  const result: [string, string][] = committeesArray.slice(0, -1).map((item: { id: Committee; name: string }) => (
    [item.name, item.id.toString()]
  ));
  return result;
};
